import {
    type FC
} from "react";
import type ISnackBarProps from "./type";
import {
    getSnackBarToastProps
} from "./util";
import Toast from "../toast";

const SnackBar: FC<ISnackBarProps> = (props) => {
    return <Toast
        {...getSnackBarToastProps(props)}
    />;
};
export default SnackBar;
